module.exports = __webpack_public_path__ + "static/assets/85288751058f7704ffdb91f15d189260.svg";